import $ from 'jquery';
import UIkit from 'uikit';

$(document).ready(function($) {
    $('.js-service-open').click(function(){
        const item = $(this).data('service-item');
        UIkit.slider('.js-service-slider').show(item);
    });
});